import clsx from 'clsx';

import type { FC, HTMLAttributes } from 'react';

import s from './GroupEmpty.module.css';

type GroupEmptyProps = HTMLAttributes<HTMLDivElement>;

const GroupEmpty: FC<GroupEmptyProps> = ({ className, ...props }) => (
  <div className={clsx(s.empty, className)} {...props} />
);

export { GroupEmpty };
